// @flow
import React, { useState } from "react";
import { NavLink, withRouter } from "react-router-dom";
import "./styles.css";
import { bindActionCreators } from "redux";
import * as modalActionCreators from "../../action-creators/modal-actions";
import * as sessionActionCreators from "../../action-creators/session-actions";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";

type PropsType = {
    actions: { [string]: any=>void }
};


const MyComponent = ({ actions }: PropsType): React$Element<any> => {

    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const logout = (e: Object): void => {
        e.preventDefault();
        // eslint-disable-next-line no-alert
        if (window.confirm("navigation.Are you sure you want to log out?")) {
            actions.logout();
        }
    };

    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const closeMenu = () => {
        if (isMenuVisible) {
            setIsMenuVisible(false);
        }
    };

    const linkConfigs = [
        {
            displayName: "Dashboard",
            to: "/dashboard",
            container: "main",
            sortOrder: 0,
            icon: "faChartLine"
        },
        {
            displayName: "Towns",
            to: "/towns",
            container: "menu",
            sortOrder: 3,
            icon: "faCity"
        },
        {
            displayName: "Messages",
            to: "/messages",
            container: "main",
            sortOrder: 1,
            icon: "faComments"
        },
        {
            displayName: "Teams",
            to: "/teams",
            container: "menu",
            sortOrder: 2,
            icon: "faHandsHelping"
        },
        {
            displayName: "Trash Drops",
            to: "/trash-drops",
            container: "menu",
            sortOrder: 2,
            icon: "faMapMarkerAlt"
        },
        {
            displayName: "Users",
            to: "/users",
            container: "menu",
            sortOrder: 1,
            icon: "faUsers"
        },
        {
            displayName: "Green Up Day",
            to: "/green-up-day",
            container: "menu",
            sortOrder: 6,
            icon: "faSun"
        },
        {
            displayName: "Tools",
            to: "/tools",
            container: "menu",
            sortOrder: 7,
            icon: "faTools"
        }
    ];

    const links = (configs: Object[]) => configs.map((link: Object, i: number) => (
        <li className={ "main-navigation--link-li" } key={ i }>
            <NavLink
                activeClassName="active"
                className="main-navigation--link"
                onClick={ closeMenu }
                title={ link.displayName }
                to={ link.to }>
                <span className={ "main-navigation--link-content" }>
                    <span className={ "main-navigation--link-content-icon" }>
                        <FontAwesomeIcon icon={ icons[link.icon] }/>
                    </span>
                    <span className={ "main-navigation--link-content-text" }>{link.displayName}</span>
                </span>
            </NavLink>
        </li>
    ))
    ;

    const mainLinks = linkConfigs.filter((link: Object) => link.container === "main").sort((a, b) => a.sortOrder - b.sortOrder);
    const menuLinks = linkConfigs.filter((link: Object) => link.container === "menu").sort((a, b) => a.sortOrder - b.sortOrder);

    return (
        <div className="main-navigation">
            <section className={ `main-navigation--menu${isMenuVisible ? " is-visible" : ""}` }>
                <button className={ "main-navigation--close-menu" } onClick={ toggleMenu }>
                    <FontAwesomeIcon icon={ icons.faTimesCircle }/>
                </button>
                <ul className={ "main-navigation--menu-links-container" }>
                    {links(menuLinks)}
                    <li className={ "main-navigation--link-li" }>
                        <span className={ "main-navigation--link" }>
                            <button className={ "main-navigation--link-content" }
                                onClick={ logout }
                            >
                                <span className={ "main-navigation--link-content-icon" }>
                                    <FontAwesomeIcon icon={ icons.faSignOutAlt }/>

                                </span>
                                <span className={ "main-navigation--link-content-text" }>
                                    {"Log Out"}
                                </span>
                            </button>
                        </span>
                    </li>
                </ul>
            </section>
            <nav className={ "main-navigation--container" }>
                <ul className={ "main-navigation--link-container" }>
                    {links(mainLinks)}
                    <li className={ "main-navigation--link-li" }>
                        <span className={ "main-navigation--menu-link" }>
                            <button
                                className={ "main-navigation--link-content" }
                                onClick={ toggleMenu }
                            >
                                <span className={ "main-navigation--link-content-icon" }>
                                    <FontAwesomeIcon icon={ icons.faBars }/>
                                </span>
                                <span
                                    className={ "main-navigation--link-content-text" }>{"Menu"}</span>
                            </button>
                        </span>
                    </li>
                </ul>
            </nav>
            <nav className={ "main-navigation--desktop-container" }>
                <ul className={ "main-navigation--link-container" }>
                    {links(mainLinks)}
                    {links(menuLinks)}
                </ul>
            </nav>
        </div>
    );
};


const mapStateToProps = (state: Object): Object => {
    const user = (state.users || { data: {} }).data[state.session.user.uid] || { photoURL: state.session.user.photoURL };
    const modals = state.modals.data;
    return ({ user, modals });
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...modalActionCreators, ...sessionActionCreators }, dispatch)
});

export const MainNavigation = connect(mapStateToProps, mapDispatchToProps)(withRouter(MyComponent));
